export interface RankInfo {
  name: string;
  background: string;
  textColor: string;
  borderColor: string;
  shadowColor: string;
}

export interface RankThreshold {
  score: number;
  name: string;
  description: string;
  background: string;
  textColor: string;
  borderColor: string;
  shadowColor: string;
}

export const RANK_THRESHOLDS: RankThreshold[] = [
  { 
    score: 50, 
    name: 'The Lost', 
    description: 'There is nothing left. Only white.',
    background: 'radial-gradient(circle at 15% 25%, #ffffff 0%, #f8f8f8 15%, transparent 20%), radial-gradient(circle at 85% 30%, #ffffff 0%, #f5f5f5 12%, transparent 18%), radial-gradient(circle at 45% 70%, #ffffff 0%, #fafafa 10%, transparent 15%), radial-gradient(circle at 70% 80%, #ffffff 0%, #f7f7f7 14%, transparent 19%), radial-gradient(circle at 25% 60%, #ffffff 0%, #f9f9f9 11%, transparent 16%), radial-gradient(circle at 60% 40%, #ffffff 0%, #f6f6f6 13%, transparent 17%), radial-gradient(circle at 35% 90%, #ffffff 0%, #f8f8f8 10%, transparent 14%), radial-gradient(circle at 90% 65%, #ffffff 0%, #fafafa 12%, transparent 16%), linear-gradient(135deg, #f5f5f5 0%, #ffffff 50%, #f8f8f8 100%)',
    textColor: '#999',
    borderColor: '#e0e0e0',
    shadowColor: 'rgba(200, 200, 200, 0.3)',
  },
  { 
    score: 45, 
    name: 'Sauce Scholar', 
    description: 'You\'ve studied in foreign lands, finding a way to finally climax.',
    background: 'radial-gradient(circle at center, #bc002d 0%, #d32f2f 20%, #f5f5f5 35%, #ffffff 50%, #ffffff 100%)',
    textColor: '#333',
    borderColor: '#bc002d',
    shadowColor: 'rgba(188, 0, 45, 0.6)',
  },
  { 
    score: 40, 
    name: 'Eternal Edger', 
    description: 'Forever balanced on the precipice, never falling, never ascending. Time has lost all meaning.',
    background: 'radial-gradient(ellipse at 20% 30%, rgba(124, 58, 237, 0.5) 0%, transparent 50%), radial-gradient(ellipse at 80% 70%, rgba(6, 182, 212, 0.5) 0%, transparent 50%), linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%)',
    textColor: '#fff',
    borderColor: '#06b6d4',
    shadowColor: 'rgba(6, 182, 212, 0.8)',
  },
  { 
    score: 35, 
    name: 'Blue Baal', 
    description: 'You are the god of fertility, yet unable to nut as all of the sauce vanishes in a blink of an eye.',
    background: 'linear-gradient(135deg, #001a33 0%, #003d6b 25%, #0066cc 50%, #0052a3 75%, #002147 100%)',
    textColor: '#fff',
    borderColor: '#0066cc',
    shadowColor: 'rgba(0, 102, 204, 0.8)',
  },
  { 
    score: 30, 
    name: 'God Gooner', 
    description: 'Was it worth it? Losing your humanity for this?',
    background: 'linear-gradient(135deg, #1a0000 0%, #4a0000 25%, #8b0000 50%, #5a0000 75%, #2d0000 100%)',
    textColor: '#fff',
    borderColor: '#8b0000',
    shadowColor: 'rgba(139, 0, 0, 0.8)',
  },
  { 
    score: 25, 
    name: 'Gooner', 
    description: 'Beyond anyone\'s understanding',
    background: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 25%, #8b5cf6 50%, #d946ef 75%, #ec4899 100%)',
    textColor: '#fff',
    borderColor: '#8b5cf6',
    shadowColor: 'rgba(139, 92, 246, 0.5)',
  },
  { 
    score: 20, 
    name: 'The Chosen', 
    description: 'Destiny calls your name',
    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    textColor: '#fff',
    borderColor: '#f5576c',
    shadowColor: 'rgba(245, 87, 108, 0.5)',
  },
  { 
    score: 15, 
    name: 'Grandmaster', 
    description: 'Among the elite',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
    textColor: '#fff',
    borderColor: '#764ba2',
    shadowColor: 'rgba(118, 75, 162, 0.5)',
  },
  { 
    score: 13, 
    name: 'Master', 
    description: 'True mastery of the craft',
    background: 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)',
    textColor: '#fff',
    borderColor: '#7c3aed',
    shadowColor: 'rgba(124, 58, 237, 0.5)',
  },
  { 
    score: 10, 
    name: 'Diamond', 
    description: 'Shining bright',
    background: 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #06b6d4 100%)',
    textColor: '#fff',
    borderColor: '#3b82f6',
    shadowColor: 'rgba(59, 130, 246, 0.5)',
  },
  { 
    score: 5, 
    name: 'Gold', 
    description: 'A solid foundation',
    background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
    textColor: '#8b6914',
    borderColor: '#f0c000',
    shadowColor: 'rgba(255, 215, 0, 0.5)',
  },
  { 
    score: 3, 
    name: 'Silver', 
    description: 'Getting the hang of it',
    background: 'linear-gradient(135deg, #e8e8e8 0%, #c0c0c0 100%)',
    textColor: '#4a5568',
    borderColor: '#a0a0a0',
    shadowColor: 'rgba(192, 192, 192, 0.5)',
  },
  { 
    score: 1, 
    name: 'Copper', 
    description: 'Your journey begins here',
    background: 'linear-gradient(135deg, #d4916e 0%, #b87333 100%)',
    textColor: '#fff',
    borderColor: '#b87333',
    shadowColor: 'rgba(184, 115, 51, 0.5)',
  },
];

export const getRankFromScore = (score: number): RankInfo => {
  // Find the highest rank that the score qualifies for
  // Array is sorted from highest to lowest score
  const rank = RANK_THRESHOLDS.find(r => score >= r.score);
  
  if (rank) {
    return {
      name: rank.name,
      background: rank.background,
      textColor: rank.textColor,
      borderColor: rank.borderColor,
      shadowColor: rank.shadowColor,
    };
  }
  
  // Unranked (score < 1)
  return {
    name: 'Unranked',
    background: '#9ca3af',
    textColor: '#fff',
    borderColor: '#6b7280',
    shadowColor: 'rgba(107, 114, 128, 0.3)',
  };
};

